import type { GA4Surface, PageViewPayload } from './types';
import { mapRouteToPageType, sanitizePagePath } from './sanitize';

export function buildPageViewPayload(
  surface: GA4Surface,
  opts: {
    path?: string;
    locale?: string;
    principalType?: PageViewPayload['principalType'];
    moduleKey?: string;
  } = {},
): PageViewPayload {
  const path =
    opts.path ??
    (typeof window !== 'undefined' ? window.location.pathname : '/');
  const sanitizedPath = sanitizePagePath(path);
  const pageType = mapRouteToPageType(sanitizedPath);

  return {
    surface,
    pageType,
    locale: opts.locale,
    principalType: opts.principalType,
    moduleKey: opts.moduleKey,
    pagePath: sanitizedPath,
  };
}
